import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next"; 
import Location from "../assets/location.png";

const HotelDetailsGallery = () => {
  const { t } = useTranslation();

  return (
    <section className="heading-box-top">
      <div className="container">
        <div className="text-heading mb-3">
          <h2 className="mb-0">
            {t("hotelName")}
          </h2>
          <p>{t("hotelAddress")}</p>
        </div>
        <div className="row">
          <div className="col-lg-8 col-md-7 mb-4">
            <div className="btn-border-sec">
              <ul className="p-0 m-0 d-flex flex-wrap align-items-center ga-2 justify-content-between list-unstyled">
                <li><Link to="#" className="btn btn-border">{t("breakfast1")}</Link></li>
                <li><Link to="#" className="btn btn-border">{t("privateParking")}</Link></li>
                <li><Link to="#" className="btn btn-border">{t("freeWifi")}</Link></li>
                <li><Link to="#" className="btn btn-border">{t("airConditioning")}</Link></li>
                <li><Link to="#" className="btn btn-border">{t("nonSmoking")}</Link></li>
                <li><Link to="#" className="btn btn-border">{t("roomService")}</Link></li>
              </ul>
              <p>
                {t("geniusDiscount")}
                <span className="d-block">{t("geniusConditions")}</span>
              </p>
              <h4 className="mt-3 mb-3">{t("aboutProperty")}</h4>
              <p><strong>{t("comfortable")}</strong> {t("comfortableDesc")}</p>
              <p><strong>{t("facilities")}</strong> {t("facilitiesDesc")}</p>
              <p><strong>{t("location")}</strong> {t("locationDesc")}</p>
            </div>
          </div>

          {/* Right Column */}
          <div className="col-lg-4 col-md-5 mb-4">
            <div className="card-contact-location">
              <div className="map-trip-box mb-4">
              <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d201492.78632499743!2d72.86696184914157!3d19.015497856965077!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3be7b9f0b81f13ad%3A0x3c12f7681185f869!2sNavi%20Mumbai%2C%20Maharashtra!5e1!3m2!1sen!2sin!4v1754131896746!5m2!1sen!2sin" width="425" height="260" style={{ border: 0 }} allowFullScreen="" loading="lazy" referrerPolicy="no-referrer-when-downgrade" title="Google Map"></iframe>
              </div>
              <div className="property-highlights-sec">
                <div className="property-highlights-box">
                  <h4 className="mb-2">{t("propertyHighlights")}</h4>
                  <p>{t("perfectStay")}</p>
                  <ul className="m-0 p-0 list-unstyled mt-4">
                    <li>
                      <Link to="#" className="d-flex gap-2">
                        <img src={Location} alt="" />
                        <span>{t("topLocation")}</span>
                      </Link>
                    </li>
                    <li className="mb-5 mt-4">
                      <strong>{t("breakfastInfo")}</strong>
                      <span className="d-block">{t("continental")}</span>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HotelDetailsGallery;
